export default "__VITE_ASSET__VALu6gwk__"